import { ExpandMore } from '@mui/icons-material';
import {
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormLabel,
  Typography
} from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import React, { FC } from 'react';
import { Link } from '../../../../components';
import { formatDate } from '../../../../helpers';

interface IMobilePunchlistReport {
  original: any;
  selectedReport: string;
  handleTitleClick: (val: any) => void;
}

export const MobilePunchlistReport: FC<IMobilePunchlistReport> = ({
  original,
  selectedReport,
  handleTitleClick
}) => {
  const classes = useStyles();
  const { territory, neighborhood, vendorName, title, dueDate, itemCount } = original;
  const heading =
    selectedReport === 'items'
      ? title
      : selectedReport === 'neighborhood'
      ? neighborhood
      : vendorName;
  const params = new URLSearchParams();
  if (selectedReport === 'neighborhood') {
    params.append('neighborhoodId', original.neighborhoodId);
  } else {
    params.append('vendorId', `${original.vendorId}`);
  }
  return (
    <Accordion className={classes.root}>
      <AccordionSummary
        className={classes.accordion}
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div className={classes.topPanelSummaryWrapper}>
          <Typography variant="body2">{heading}</Typography>
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        {selectedReport !== 'vendor' && (
          <div className={classes.panelSummaryWrapper}>
            <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
              Territory:
            </FormLabel>
            <Typography component="span" variant="body2">
              {territory || '--'}
            </Typography>
          </div>
        )}
        {selectedReport !== 'vendor' && (
          <div className={classes.panelSummaryWrapper}>
            <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
              Neighborhood:
            </FormLabel>
            <Typography component="span" variant="body2">
              {neighborhood || '--'}
            </Typography>
          </div>
        )}
        {selectedReport !== 'neighborhood' && (
          <div className={classes.panelSummaryWrapper}>
            <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
              Vendor:
            </FormLabel>
            <Typography component="span" variant="body2">
              {vendorName || '--'}
            </Typography>
          </div>
        )}
        {selectedReport === 'items' && (
          <div className={classes.panelSummaryWrapper}>
            <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
              Title:
            </FormLabel>
            <Button
              sx={{ textAlign: 'left' }}
              onClick={() => {
                handleTitleClick(original);
              }}
            >
              <Typography component="span" variant="body2">
                {title || '--'}
              </Typography>
            </Button>
          </div>
        )}
        {selectedReport === 'items' && (
          <div className={classes.panelSummaryWrapper}>
            <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
              Due Date:
            </FormLabel>
            <Typography component="span" variant="body2">
              {formatDate(dueDate) || '--'}
            </Typography>
          </div>
        )}
        {selectedReport !== 'items' && (
          <div className={classes.panelSummaryWrapper}>
            <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
              Item Count:
            </FormLabel>
            <Typography component="span" variant="body2">
              <Link to={`/production/punchlists/todos?${params.toString()}`}>
                {itemCount || '0'}
              </Link>
              ;
            </Typography>
          </div>
        )}
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '&:first-child': { marginTop: 0 }
  },
  panelSummaryWrapper: {
    '&:first-child': { marginTop: 0 }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    backgroundColor: theme.palette.grey[100]
  },
  roleWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  editButton: {
    padding: `2px 5px`
  },
  deleteButton: {
    padding: `2px 5px`,
    color: theme.palette.error.main
  },
  boldName: {
    color: theme.palette.typography.labels,
    fontWeight: 600
  },
  subLabel: {
    marginRight: 10,
    fontSize: theme.typography.body2.fontSize
  },
  buttonsWrapper: {
    display: 'flex'
  }
}));
